<template>
  <!-- -->
  <Modal
    v-model="git_live"
    width="600px"
    class-name="vertical-center-modal"
    @on-cancel="cancel"
    :closable="false"
    :mask-closable="false"
  >
    <div style="min-height: 400px">
      <p class="livs_TOP">该名片已停用</p>
      <p class="livs_TOP">如果您是作者想给本刊投稿或者查询进度。点击下方名片与采编联系</p>
      <div class="left_center" @click="check">
        <h3>
          <img
            style="width: 50px; height: 50px"
            v-if="card_list.perLogo"
            :src="$global.imgUrl + card_list.perLogo"
          />
          {{ card_list.perName }}
        </h3>
        <div class="menust">
          <img v-if="card_list.perImg" :src="$global.imgUrl + card_list.perImg" />
          <div class="times_lives">
            <h4>
              {{ card_list.name
              }}<span v-text="card_list.editType == 1 ? '采编' : '组稿人'"></span>
            </h4>
            <p>{{ card_list.phone }}</p>
            <!--  class="livest" -->
            <div style="margin-top: 30px; display: flex">
              <Poptip placement="right" trigger="hover">
                <img
                  class="tu_image"
                  style="width: 48px; height: 31px; padding-right: 15px"
                  :src="$global.imgUrl + card_list.websiteCode"
                />
                <div slot="content">
                  <img
                    :src="$global.imgUrl + card_list.websiteCode"
                    style="width: 130px; height: 102px; padding-right: 5px"
                  />
                </div>
              </Poptip>
              <!-- <img
                class="tu_image"
                style="width: 48px; height: 31px; padding-right: 15px"
                :src="$global.imgUrl + card_list.websiteCode"
              /> -->
              <div class="new_list">
                <p>{{ dataList.urlName ? dataList.urlName : card_list.stampName }}</p>
                <p>{{  dataList.url ? dataList.url :card_list.website }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="holder_cards" @click="card">名片夹></div>
    </div>

    <div slot="footer"></div>
  </Modal>
</template>
<script>
var vm;
export default {
  props: ["liveTop"],
  name: "",
  data() {
    return {
      formItem: {
        input: "",
      },
      editId: "",
      git_live: false,
      card_list: [],
    };
  },
  components: {},
  created() {
    vm = this;
    this.$root.Bus.$on("analysisClick", function (msg, userId) {
      setTimeout(() => {
        vm.git_live = msg;
        vm.editId = userId;
        vm.getCards();
      }, 1000);
    });
    vm.getPerEditCardConfig();
  },
  mounted() {},
  methods: {
    getPerEditCardConfig() { 
      this.$apis.manage
      .getPerEditCardConfig({perId:this.$route.query.perId}).then((res) => {
        this.dataList = res.periodicalEditCardConfig
      })
    },
    next() {
      // vm.liveTop = false;
    },
    getCards() {
      var data = {
        perId: this.$store.state.qikanId,
        editId: vm.editId,
      };
      vm.$apis.manage.detailsLive(data).then((res) => {
        vm.card_list = res.data;
      });
    },
    cancel() {
      vm.git_live = false;
      vm.$emit("passwords", vm.git_live);
    },
    //交接人采编
    check() {
      //console.log(location.pathname +'?editId='+vm.editId +'&perId='+this.$store.state.qikanId)
      //return
      location.href =
        location.pathname +
        "?editId=" +
        vm.editId +
        "&perId=" +
        this.$store.state.qikanId;
    },
    //名片夹
    card() {
      // if (sessionStorage.getItem("token") == undefined) {
      //   this.$root.Bus.$emit(
      //     "analy",
      //     true,
      //     "/cardHolder?editId=" + vm.editId + "&perId=" + this.$store.state.qikanId
      //   );
      //   this.$Message.success("请登录您的用户");
      // } else {
      //   vm.git_live = false;
      //   vm.$router.push({
      //     path: "/cardHolder",
      //     query: {
      //       editId: vm.editId,
      //       perId: this.$store.state.qikanId,
      //     },
      //   });
      // }
      var token = window.sessionStorage.getItem("token", token);
      var urlList = "";
      if (token) {
        this.$apis.manage.getUserInfo().then((res) => {
          if (res.resultCode == 200) {
            if (
              location.host.indexOf("cbtest.") != -1 ||
              location.host.indexOf("127.") != -1 ||
              location.host.indexOf("localhost") != -1
            ) {
              urlList = "https://dev.cnknowledge.com/newtsgweb/?token="; //
            } else if (location.host.indexOf("yucard") != -1) {
              urlList = "https://yutsg.cnknowledge.com/newtsgweb?token="; //
            } else {
              urlList = "https://publish.cnknowledge.com/newtsgweb?token="; //
            }
            var mywin = window.open(`${urlList}&editId=${this.$store.state.cbianId}&prid=${this.$store.state.qikanId}#/manage/nameCard`);
            mywin.location.reload(true);
          }
        });
      } else {
        this.$root.Bus.$emit("analy", true);
        // this.$Message.error("请登录您的用户");
      }
    },
  },
};
</script>
<style scoped="scoped" lang="scss">
.flex_left {
  display: flex;
  justify-content: space-between;
}

/deep/.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
}
/deep/ .ivu-input {
  height: 45px;
  padding-left: 55px;
}
.zhuce {
  padding-top: 0px;
  padding-bottom: 30px;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2150cb;
  line-height: 24px;
}
.liItem {
  position: relative;
}
.liItem img {
  display: block;
  position: absolute;
  top: 10px;
  left: 15px;
  z-index: 999999;
}
.top_input /deep/ .ivu-input {
  width: 240px;
}
/deep/.ivu-modal-footer {
  display: none;
}
.passwor {
  text-align: right;
  cursor: pointer;
}
.livs_TOP {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #494949;
  line-height: 36px;
  text-align: center;
}
.holder_cards {
  text-align: right;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #2150cb;
  line-height: 24px;
  padding-right: 30px;
  margin-top: 30px;
  cursor: pointer;
}
.left_center {
  width: 450px;
  height: 288px;
  margin: 30px auto;
  background: url(../../../assets/image/card_bg.png) no-repeat;
  background-size: 100% 100%;
  position: relative;
}
.left_center h3 {
  margin-left: 40px;
  padding-top: 35px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #433f3f;
  line-height: 36px;
}
.left_center h3 img {
  vertical-align: middle;
  margin-right: 15px;
  border-radius: 50%;
}
.menust {
  margin-top: 30px;
  margin-left: 45px;
}
.menust img {
  width: 150px;
  height: 150px;
  display: block;
  float: left;
  padding-right: 40px;
}
.times_lives h4 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 32px;
}
.times_lives h4 span {
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 32px;
  padding-left: 30px;
}
.times_lives p {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 32px;
}

.livest {
  margin-top: 35px;
}
.tu_image {
  display: block;
  float: left;
  padding-right: 20px;
}
.new_list p {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #433f3f;
  line-height: 16px;
}
.moten_list {
  width: 120px;
  height: 100%;
  position: absolute;
  right: -125px;
  top: 0px;
}
.list_mation {
  width: 100%;
  height: 36px;
  background: #ffffff;
  border-radius: 0px 10px 10px 0px;
  text-align: center;
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #2150cb;
  line-height: 36px;
  cursor: pointer;
  position: relative;
}
.share_live {
  width: 100%;
  position: absolute;
  top: -50px;
  left: 0px;
}
.list_mation img {
  width: 22px;
  height: 22px;
  vertical-align: middle;
}
.chalist {
  position: absolute;
  right: 0px;
  bottom: 10px;
}
.new_list{
  word-break: break-all;
}
</style>
